import React from "react";

 const Servises = () => {
return (
	<div className="home">
	<h1><span className="color1">S</span><span className="color2">E</span><span className="color3">R</span><span className="color4">V</span><span className="color6">I</span><span className="color1">C</span><span className="color2">S</span></h1>
<p>
&emsp;&emsp;&emsp;&emsp;&emsp;The dream of Modern Public School is co-created with the community of teachers, parents, and children to be the benchmark of excellence in education in a changing India. We, therefore, strive to lay the foundation for healthy productive & satisfying life in the future, by enabling the children to develop her/his maximum potential through:-
</p>
<p>
&emsp;&emsp;&emsp;&emsp;&emsp;Physical well : being Health & Motor Development, Personal, Social and Emotional Development, Creative, and Aesthetic Development, Language, Communications & Literacy Development, Cognitive development-Environmental Awareness, Development of Scientific Temper and developing Mathematical Thinking & Reasoning.
</p>

	</div>
);
};export default Servises;